export { default as LogoStateless } from './logo-stateless';
